module.exports = __webpack_public_path__ + "static/assets/dd575f1b468f022f6e32fec5576d5832.png";